import keyMirror from "keymirror"

export default keyMirror({
  info: null,
  warning: null,
  success: null,
  danger: null,
})
